import React, { createContext, useEffect, useContext, useRef } from 'react';

var addScriptToHead = function addScriptToHead(scriptSrc) {
  if (!scriptSrc) {
    throw Error('Adobe Analytics scriptSrc is required');
  } // bail out if the script has already been added


  var scripts = document.getElementsByTagName('script');
  var count = scripts.length;

  for (var i = 0; i < count; i += 1) {
    if (scripts[i].getAttribute('src') === scriptSrc) {
      return;
    }
  }

  var script = document.createElement('script');
  script.setAttribute('src', scriptSrc);
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('async', 'true');
  document.head.appendChild(script);
}; // this is the only place that directly accesses `window.appEventData`

var track = function track(event) {
  if (typeof window.appEventData === 'undefined') {
    throw new Error('[@chr/react-analytics] `window.appEventData` is undefined. Check ' + 'your app code to make sure you are not modifying or deleting it.');
  }

  window.appEventData.push(event);
};
var hasProperties = function hasProperties(object) {
  if (!object) {
    return false;
  }

  for (var prop in object) {
    if (object.hasOwnProperty(prop)) {
      return true;
    }
  }

  return false;
};

var AnalyticsContext = /*#__PURE__*/createContext(track);

var AnalyticsProvider = function AnalyticsProvider(_ref) {
  var scriptSrc = _ref.scriptSrc,
      children = _ref.children;
  useEffect(function () {
    addScriptToHead(scriptSrc);
  }, [scriptSrc]);
  return /*#__PURE__*/React.createElement(AnalyticsContext.Provider, {
    value: track
  }, children);
};

/**
 * @description The returns a track function allows the consumer to track an
 * event independent of the useEffect call, for example, in a event handler.
 */

var useAnalyticsTrack = function useAnalyticsTrack() {
  return useContext(AnalyticsContext);
};

/**
 * @description This will push a new event to the data layer every time the
 * event object changes, as a standard useEffect dependency. Enable once
 * to log the event a single time, or memoize the event object in the parent
 * component.
 */
var useAnalyticsEvent = function useAnalyticsEvent(event) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var runRef = useRef(false);
  var track = useAnalyticsTrack();
  useEffect(function () {
    if (!!opts.once && !runRef.current || !opts.once) {
      track(event);
      runRef.current = true;
    }
  }, [event, track, opts.once]);
};

var loadInfoEvent = function loadInfoEvent(load) {
  return {
    event: 'loadInfo',
    load: load
  };
};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _defineProperty = unwrapExports(defineProperty);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var pageInfoEvent = function pageInfoEvent(page, site) {
  return _objectSpread(_objectSpread({
    event: 'pageInfo'
  }, hasProperties(page) && {
    page: page
  }), hasProperties(site) && {
    site: site
  });
};

var searchEvent = function searchEvent(search) {
  return {
    event: 'search',
    search: search
  };
};

var searchItemClickedEvent = function searchItemClickedEvent(linkInfo) {
  return {
    event: 'searchItemClicked',
    linkInfo: linkInfo
  };
};

var userDetectedEvent = function userDetectedEvent(user) {
  return {
    event: 'userDetected',
    user: user
  };
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var pageInitializedEvent = function pageInitializedEvent(data) {
  return _objectSpread$1({
    event: 'pageInitialized'
  }, data);
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var pageLoadCompletedEvent = function pageLoadCompletedEvent(data) {
  return _objectSpread$2({
    event: 'pageLoadCompleted'
  }, data);
};

var filterChangedEvent = function filterChangedEvent(data) {
  return {
    event: 'filterChanged',
    data: data
  };
};

window.appEventData = window.appEventData || [];

export { AnalyticsProvider, filterChangedEvent, loadInfoEvent, pageInfoEvent, pageInitializedEvent, pageLoadCompletedEvent, searchEvent, searchItemClickedEvent, useAnalyticsEvent, useAnalyticsTrack, userDetectedEvent };
//# sourceMappingURL=index.es.js.map
